/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/motherhood/components/standalone/TagsIndex/theme';

export const TagsIndexTheme = theme;
